module.exports = __webpack_public_path__ + "img/prixi-nobg.0a6637e9.png";